import React from 'react';
import { YearProps } from '../types/Calendar.types';

export const Year: React.FC<YearProps> = ({
  year,
  isSelected,
  isDisabled,
  onClick,
  className = '',
}) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!isDisabled) {
      onClick(year);
    }
  };

  const getYearClassName = () => {
    let baseClasses =
      'ui-w-[74px] ui-h-[48px] ui-flex ui-items-center ui-font-body-xs-medium ui-justify-center ui-text-body-xs-medium ui-leading-body-xs-medium ui-tracking-body-xs ui-rounded ui-cursor-pointer ui-transition-colors';

    if (isDisabled) {
      baseClasses += ' ui-text-disabled ui-cursor-not-allowed';
    } else if (isSelected) {
      baseClasses += ' ui-bg-fill-brand ui-text-on-color';
    } else {
      baseClasses += ' hover:ui-bg-surface-brand hover:ui-text-brand';
    }

    return `${baseClasses} ${className}`;
  };

  return (
    <div
      className={getYearClassName()}
      onClick={handleClick}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-label={`Año ${year}`}
      aria-selected={isSelected}
      aria-disabled={isDisabled}
    >
      {year}
    </div>
  );
};
